module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/578cb2e6df722f86b9fe84daa5e01e34.png";